import { List, Map, Record } from 'immutable';

export default Record({
    id: '',
    pivot: Map({
        days: null,
        values: Map({}),
    }),
    requiredFields: List([]),
    template: '',
    title: '',
    type: '',
});



// WEBPACK FOOTER //
// ./src/records/followUp.js